import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'

const Column = ({config, clickHandler}) => {

    const IconCards = config.map((job, index) => {
    const { description, src, title, type } = job;

      return (
        <div  className="materials" key={index}>
          <div className="materials-grid">

            <div className="grid-cell">
              <img src={src} alt={title} className="icon" />
            </div>

            <div className="grid-cell" style={{paddingLeft: '10px'}}>
              <h4 className="material-title">{title.toUpperCase()}</h4>
              <p className="material-description">{description}</p>
            </div>

            <div className="grid-cell">
              <div className="material-buttons">
                  <RaisedButton
                    className="view-button"
                    label="Volunteer"
                    onClick={() => { clickHandler(`${type} Volunteers - ${title}`)}}
                    primary={true}
                    style={{width: '200px', marginTop: '10px', marginBottom: '5px'}}
                  />
              </div>
            </div>
          </div>
        </div>
      );
    })

    return (
      <div>
        {IconCards}
      </div>
    );
}

export default Column



// WEBPACK FOOTER //
// ./src/components/GetInvolved/GetInvolvedColumn.js